import api from "@/api/axios";

const resource = "cars";

export default {
  // ==================== List ====================
  getAll(params = {}) {
    return api.get(`/${resource}`, { params }); // endpoint في باك إند بيرجع كل العربيات
  },
  getCars(params = {}) {
    return api.get(`/${resource}`, { params });
  },

  // ==================== Show ====================
  getCar(id) {
    return api.get(`/${resource}/${id}`);
  },

  // ==================== Create ====================
  // formData يجب أن يكون FormData عند الإرسال
  create(formData) {
    return api.post(`/${resource}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // ==================== Update ====================
  update(id, formData) {
    return api.post(`/${resource}/${id}?_method=PUT`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // ==================== Delete ====================
  delete(id) {
    return api.delete(`/${resource}/${id}`);
  },

  // ==================== Master Data ====================
  getMasterData() {
    return api.get("/cars/master-data");
  },
};
